import { createSelector } from 'reselect'

const sidebarPlaceholderSelector = (state) => state.sidebar_placeholder

export const isSidebarOpenSelector = createSelector(sidebarPlaceholderSelector, ({ isSidebarOpen }) => isSidebarOpen)
